import { useNow } from '@lib/hooks/useNow';
import { ArrowBackRounded } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { AppPage } from '@pages/AppPage';
import { scheduleSettings } from '@stores/ScheduleSettings';
import { observer } from 'mobx-react-lite';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { PostForm } from './PostForm/PostForm';
import { PostFormProvider } from './PostForm/PostFormStore';
import css from './PostPages.module.scss';
import { schedulePath } from './schedulePath';

/**
 * `/schedule/create/:renderId`: schedule a render to one or more connected
 * accounts. With none connected the form still shows, its account list
 * holding only the card that connects one.
 */
export const ComposePage = observer(function ComposePage() {
  const { renderId } = useParams<{ renderId: string }>();
  const navigate = useNavigate();
  // Ticking, so "this time has passed" under the picker can turn on while the page stays open.
  const now = scheduleSettings.inZone(useNow());
  if (!renderId) return <Navigate to="/schedule" replace />;

  return (
    <AppPage header="Schedule a post">
      <div className={css.container}>
        <div className={css.headerStrip}>
          <IconButton
            className={css.backButton}
            aria-label="Back to the schedule"
            onClick={() => navigate(schedulePath(null, now))}
          >
            <ArrowBackRounded />
          </IconButton>
          <h2 className={css.title}>Schedule a post</h2>
        </div>
        <div className={css.scrollableContent}>
          <PostFormProvider arguments={['create', renderId]}>
            <PostForm now={now} />
          </PostFormProvider>
        </div>
      </div>
    </AppPage>
  );
});
